import { render, staticRenderFns } from "./DailyJournal.vue?vue&type=template&id=2b5181ee&scoped=true"
import script from "./DailyJournal.vue?vue&type=script&lang=js"
export * from "./DailyJournal.vue?vue&type=script&lang=js"
import style0 from "./DailyJournal.vue?vue&type=style&index=0&id=2b5181ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5181ee",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QSeparator,QCard,QIcon,QChip,QDialog,QForm,QSelect,QPopupProxy,QDate,QItem,QToggle,QCheckbox,QField});qInstall(component, 'directives', {ClosePopup});
